import { FORM_KEY, openPopupTab } from '@publishing/modules/forms';

export const ESTIMATE_HREF = '/estimate-new';

// shared-office 무료 견적 받기와 동일한 리드폼 탭 팝업.
export const openDefaultConsultPopup = () =>
  openPopupTab(FORM_KEY.SHARED_OFFICE);
